module.exports = __webpack_public_path__ + "img/pantip.cd05077b.svg";